import React, { Children, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { func, bool } from "prop-types";

import classNames from "classnames";

import { actions } from "reducers/drawer";

import Button from "pages/_components/Button";

const Options = (props) => {
    const { children, options, handleClose } = props;
    const optionsRef = useRef(null);
    const isVisible = useSelector(({ drawer }) => drawer.displayMenu);
    const dispatch = useDispatch();

    // const [openSidebar, setVisible] = useState(false);

    const closeMenu = () => {
        dispatch(actions.menuClose());
    };

    const handleClick = (event) => {
        if (optionsRef.current && !optionsRef.current.contains(event.target) && isVisible) {
            if (handleClose) {
                handleClose();
            } else {
                closeMenu();
            }
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick, true);
        return () => {
            document.removeEventListener("click", handleClick, true);
        };
    }, [handleClick]);

    const renderChildren = () =>
        Children.toArray(children).reduce((result, child, index) => {
            if (child) {
                const id = index;
                return [
                    ...result,
                    React.cloneElement(
                        <li className="navigational-list-item" key={id}>
                            {child}
                        </li>,
                    ),
                ];
            }
            return result;
        }, []);

    return (
        <div className={classNames("slider", "slideFromBottom", { "is-shown": isVisible })}>
            <div ref={optionsRef} className="slideFromBottom-wrapper">
                <Button block className="btn btn-link drawer-close" onClick={closeMenu} image="drawer-close.svg" />
                <ul className="navigational-list">{renderChildren()}</ul>
            </div>
        </div>
    );
};

Options.propTypes = {
    isVisible: bool,
    dispatch: func.isRequired,
};

Options.defaultProps = (state) => ({
    isVisible: false,
});

// const mapStateToProps = (state) => ({
//     isVisible: selectors.getDisplayMenu(state),
// });

export default Options;
